<template>
  <v-container>
    <v-row class="top-bar"><v-btn @click="back()" text>&lt; Back To {{from || 'DEALS'}}</v-btn></v-row>
    <coin-summary :coin="coin" currency="BTC" />
    <product :item="item">
      <template v-slot:s1="{ item, currency }">
        {{currency === 'USD' ? item.priceUsd : item.priceBtc | unitPrice(coin, currency, currency === 'USD' ? 4 : 8)}}
        <span class="subtitle-1">
          /TH
        </span>
      </template>
      <template v-slot:s2="{ item }">
        <span class="dealMeta">Breakeven Days</span>
        <span class="body-1 font-weight-bold"><colored :value="item.breakevenDays" format="breakeven" /></span>
      </template>
    </product>
    <product-detail :item="item">
      <template v-slot:income-with-halving="{ item }">
        <tr><th>Block Reward /TH/Day</th></tr>
        <tr><td>Pre-halving</td><td><colored :value="item.payoff" :coin="coin" :digits="4" /></td></tr>
        <tr><td>Post-halving</td><td><colored :value="item.payoff / 2" :coin="coin" :digits="4" /></td></tr>
      </template>
      <template v-slot:cost-with-halving="{ item }">
        <tr><td>Total Upfront</td><td><colored :value="-item.priceUsd" :coin="coin" :digits="2" /></td></tr>
        <tr><td>Daily fee</td><td><colored :value="-item.elecFeeUnit" :coin="coin" :digits="4" /></td></tr>
      </template>
      <template v-slot:profit-with-halving="{ item }">
        <tr><th>Net Profit /TH/Day</th><td></td></tr>
        <tr><td>Pre-halving</td><td><colored :value="item.payoff - item.elecFeeUnit" :coin="coin" :digits="4" /></td></tr>
        <tr><td>Post-halving</td><td><colored :value="item.payoff / 2 - item.elecFeeUnit" :coin="coin" :digits="4" /></td></tr>
      </template>
    </product-detail>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import { price, unitPrice, unit, date } from "../filters";
import CoinSummary from "../components/CoinSummary";
import Colored from "../components/Colored";
import Product from "../components/product/Product";
import ProductDetail from "../components/product/ProductDetail";

export default {
  name: "ProductLifetime",
  filters: { price, unitPrice, unit, date },
  components: { CoinSummary, Colored, Product, ProductDetail },
  methods: {
    back() { history.back(); }
  },
  computed: {
    ...mapState(["blockchain"]),
    ...mapGetters("contracts", ["getContractById"]),
    item() {
      const { id } = this.$route.query;
      return this.getContractById(id);
    }
  },
  data() {
    const { from } = this.$route.query;
    return {
      from,
      coin: 'BTC'
    };
  }
}
</script>

<style scoped>

</style>